// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"bdbe8910","513":"ffebf88a","703":"9e49a23a"}[chunkId] + ".chunk.js";
};